import { Skeleton } from "@mui/material";

/**
 * Loading screen for mailbox page.
 * It consists of mailbox owner's avatar, name, form fields
 * and dropzone's placeholder as MUI skeleton with wave animation.
 *
 * @returns Placeholder skeletons for mailbox owner's avatar, name, form fields
 * and dropzone with exact same layout as that of components in mailbox page.
 */
export const MailboxLoadingScreen = () => {
  return (
    <div className="container mx-auto max-w-screen-lg md:w-3/4">
      <div className="mb-7 flex flex-row items-start sm:m-0 sm:items-center">
        {/* User avatar skeleton  */}
        <Skeleton animation="wave" variant="circular" width={55} height={55} />
        <div className="w-5" />
        <div className="flex flex-1 flex-col">
          {/* Username text skeleton */}
          <Skeleton animation="wave" variant="text" width={180} height={26} />
          {/* [Mobile] Slogan text skeleton  */}
          <div className="sm:hidden">
            <Skeleton
              animation="wave"
              variant="text"
              width={"70%"}
              height={20}
            />
          </div>
        </div>
      </div>

      {/* [Desktop] slogan text skeleton */}
      <div className="hidden sm:block">
        <div className="flex flex-row items-center justify-between pt-3">
          <Skeleton animation="wave" variant="text" width={390} height={40} />
        </div>
      </div>

      {/* Form fields skeletons */}
      <div className="mt-5 flex flex-col gap-y-5">
        {/* Your name + Your email address */}
        <div className="flex flex-col gap-y-5 sm:flex-row sm:gap-x-5">
          {/* Name field skeleton */}
          <Skeleton
            animation="wave"
            className="w-full sm:flex-1"
            variant="rectangular"
            height={56}
          />
          {/* Email field skeleton */}
          <Skeleton
            animation="wave"
            className="w-full sm:flex-1"
            variant="rectangular"
            height={56}
          />
        </div>

        {/* Subject field skeleton*/}
        <Skeleton
          animation="wave"
          className="w-full"
          variant="rectangular"
          height={56}
        />

        {/* Message field skeleton */}
        <Skeleton
          animation="wave"
          className="w-full"
          variant="rectangular"
          height={150}
        />

        {/* Dropzone */}
        <div className="hidden sm:visible">
          <Skeleton
            animation="wave"
            className="n w-full"
            variant="rectangular"
            height={140}
          />
        </div>
      </div>
    </div>
  );
};

export default MailboxLoadingScreen;
